<!-- ── CAPITAL GROWTH CALCULATOR ── -->
<app-ip-shell
  [activeStep]="2"
  [steps]="cgSteps"
  calculatorName="Capital Growth Calculator">

  <!-- ── FORM COLUMN ── -->
  <div formCol>
    <div class="ip-form-head">
      <div class="ip-form-head__step-meta">Capital Growth Calculator</div>
      <h1 class="ip-form-head__title">Project your property's capital growth</h1>
      <p class="ip-form-head__subtitle">
        Estimate long-term property value growth in GBP and your home currency — including FX appreciation for overseas buyers.
      </p>
    </div>

    <div class="ip-form-body">

      <!-- Home Currency (foreign buyers only) -->
      <div class="ip-field" *ngIf="foreignbuyer==='1'">
        <div class="ip-field__head">
          <label class="ip-field__label">Home currency</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>Returns shown in your currency</span>
        </div>
        <div class="s3-currency-wrap">
          <button
            type="button"
            class="s3-currency-btn"
            (click)="currencyDropdownOpen=!currencyDropdownOpen"
            [class.open]="currencyDropdownOpen">
            <span class="s3-currency-val" [class.placeholder]="!homecurrencyText">
              {{ homecurrencyText ? selectedCurrencyName : 'Select currency' }}
            </span>
            <svg class="s3-currency-chevron" [class.rotated]="currencyDropdownOpen" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>
          </button>
          <div class="s3-dropdown" *ngIf="currencyDropdownOpen">
            <div class="s3-dropdown__search">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
              <input
                type="text"
                class="s3-dropdown__input"
                placeholder="Search currency..."
                [(ngModel)]="currencySearch"
                autocomplete="off"
                (click)="$event.stopPropagation()">
            </div>
            <div class="s3-dropdown__list">
              <div
                *ngFor="let c of filteredCurrencies"
                class="s3-dropdown__item"
                [class.selected]="homecurrencyText === c.code"
                (click)="selectCurrency(c.code)">
                <span class="s3-dropdown__item-name">{{ c.name.replace(' (' + c.code + ')', '') }}</span>
                <span class="s3-dropdown__item-code">{{ c.code }}</span>
              </div>
              <div class="s3-dropdown__empty" *ngIf="filteredCurrencies.length === 0">No currencies found</div>
            </div>
          </div>
        </div>
        <p class="ip-field-error" *ngIf="homeCurrencyError">This field is required</p>
      </div>

      <!-- FX Rate (foreign buyers, read-only) -->
      <div class="ip-field" *ngIf="foreignbuyer==='1' && homecurrencyText && homecurrency">
        <div class="ip-field__head">
          <label class="ip-field__label">FX rate (1 GBP)</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>Live rate</span>
        </div>
        <div class="ip-input">
          <input type="text" class="ip-input__field" [value]="homecurrency || '—'" readonly>
          <span class="ip-input__suffix">{{ homecurrencyText }}</span>
        </div>
      </div>

      <!-- Property Value -->
      <div class="ip-field">
        <div class="ip-field__head">
          <label class="ip-field__label" for="propertyValue">Property value</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>UK avg: £280k</span>
        </div>
        <div class="ip-input">
          <span class="ip-input__prefix">£</span>
          <input
            type="text"
            id="propertyValue"
            class="ip-input__field"
            autocomplete="off"
            placeholder="e.g. 280,000"
            [(ngModel)]="PropertyValue"
            (keyup)="PropertyValue=validation.amountWithComma(PropertyValue)"
            (keypress)="validation.numberOnly($event)">
        </div>
      </div>

      <!-- Annual Capital Growth -->
      <div class="ip-field">
        <div class="ip-field__head">
          <label class="ip-field__label" for="capitalgrowth">Annual capital growth</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>10yr UK avg: 4.8%</span>
        </div>
        <div class="ip-input">
          <input
            type="text"
            id="capitalgrowth"
            class="ip-input__field"
            autocomplete="off"
            placeholder="e.g. 4.8"
            [(ngModel)]="capitalgrowth"
            (keyup)="capitalgrowth=validation.appendPercent($event,capitalgrowth)"
            (keypress)="validation.DesimalOnly($event,capitalgrowth)">
          <span class="ip-input__suffix">% p.a.</span>
        </div>
      </div>

      <!-- FX Appreciation -->
      <div class="ip-field">
        <div class="ip-field__head">
          <label class="ip-field__label" for="FXGrowthPA">FX appreciation</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>GBP vs {{ homecurrencyText || 'home currency' }}</span>
        </div>
        <div class="ip-input">
          <input
            type="text"
            id="FXGrowthPA"
            class="ip-input__field"
            autocomplete="off"
            placeholder="e.g. 3"
            [(ngModel)]="FXGrowthPA"
            (keyup)="FXGrowthPA=validation.appendPercent($event,FXGrowthPA)"
            (keypress)="validation.DesimalOnly($event,FXGrowthPA)">
          <span class="ip-input__suffix">% p.a.</span>
        </div>
      </div>

      <!-- Investment Period -->
      <div class="ip-field">
        <label class="ip-field__label">Investment period</label>
        <div class="ip-chip-row">
          <button class="ip-chip" [class.is-active]="investedTenure==='5'"  (click)="investedTenure='5'"  type="button">5 yrs</button>
          <button class="ip-chip" [class.is-active]="investedTenure==='10'" (click)="investedTenure='10'" type="button">10 yrs</button>
          <button class="ip-chip" [class.is-active]="investedTenure==='15'" (click)="investedTenure='15'" type="button">15 yrs</button>
        </div>
      </div>

    </div><!-- /ip-form-body -->

    <div class="ip-form-actions">
      <button class="ip-btn ip-btn--ghost" type="button" [routerLink]="['/capital-growth-calculator/step1']">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline>
        </svg>
        Back
      </button>
      <button class="ip-btn ip-btn--accent" type="button" (click)="next()">
        Calculate Returns
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </button>
    </div>
  </div><!-- /formCol -->

  <!-- ── RAIL — live growth preview ── -->
  <div rail>
    <div class="ip-rail-summary">
      <div class="ip-rail-summary__head">
        <div class="ip-rail-summary__loc">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>
          </svg>
          <span class="ip-rail-summary__loc-name">{{ calcData?.City || 'United Kingdom' }}</span>
        </div>
        <div class="ip-rail-summary__buyer-tag" [class.is-uk]="foreignbuyer!=='1'">
          {{ foreignbuyer === '1' ? 'Foreign Buyer' : 'UK Resident' }}
        </div>
      </div>

      <div class="ip-rail-summary__body">

        <!-- Current value -->
        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">Today</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">Property value</span>
            <span class="ip-rs-row__val">{{ previewCurrentGBP ? ('£' + (previewCurrentGBP | number:'1.0-0')) : '—' }}</span>
          </div>
          <div class="ip-rs-row" *ngIf="foreignbuyer==='1' && previewCurrentHome">
            <span class="ip-rs-row__key">In {{ homecurrencyText }}</span>
            <span class="ip-rs-row__val">{{ previewCurrentHomeCr }}</span>
          </div>
          <div class="ip-rs-row" *ngIf="capitalgrowth">
            <span class="ip-rs-row__key">Growth rate</span>
            <span class="ip-rs-row__val">{{ capitalgrowth }} p.a.</span>
          </div>
        </div>

        <!-- Projected exit value -->
        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">Exit ({{ investedTenure || '?' }} yr)</span>
            <span class="ip-rs-section__total">{{ previewExitGBP ? ('£' + (previewExitGBP | number:'1.0-0')) : '—' }}</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">GBP exit value</span>
            <span class="ip-rs-row__val">{{ previewExitGBP ? ('£' + (previewExitGBP | number:'1.0-0')) : '—' }}</span>
          </div>
          <div class="ip-rs-row" *ngIf="foreignbuyer==='1' && previewExitHome">
            <span class="ip-rs-row__key">{{ homecurrencyText }} exit</span>
            <span class="ip-rs-row__val">{{ previewExitHomeCr }}</span>
          </div>
        </div>

        <!-- Total return -->
        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">Return</span>
          </div>
          <div class="ip-rs-row" *ngIf="FXGrowthPA">
            <span class="ip-rs-row__key">FX appreciation</span>
            <span class="ip-rs-row__val">{{ FXGrowthPA }} p.a.</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">Total {{ homecurrencyText || 'home' }} return</span>
            <span class="ip-rs-row__val">{{ previewTotalReturn ? (previewTotalReturn + '%') : '—' }}</span>
          </div>
        </div>

      </div>

      <div class="ip-rail-summary__outlay">
        <div class="ip-rail-summary__outlay-label">Total {{ homecurrencyText || 'GBP' }} return</div>
        <div class="ip-rail-summary__outlay-value">{{ previewTotalReturn ? (previewTotalReturn + '%') : '—' }}</div>
        <div class="ip-rail-summary__outlay-meta">Over {{ investedTenure || '?' }} years incl. FX</div>
      </div>
    </div>
  </div><!-- /rail -->

</app-ip-shell>
